import React, { FC } from 'react';

import { LinkList } from '@eika/link-list';

import EfakturaAgreement from '../../components/EfakturaAgreement/EfakturaAgreement';
import { Content } from '../../components/shared/Content';
import { useConfig } from '../../defaultConfig';
import useProfile from '../../fetchHooks/useProfile';
import useTranslation from '../../hooks/useTranslation';

import '../Settings/Settings.scss';

const PaymentSettings: FC = () => {
    const { avtalegiroLink, paymentLimitsLink, featureToggles } = useConfig();
    const translated = useTranslation();
    const userInfo = useProfile(featureToggles.enablePaymentLimits);
    const isOfLegalAge = userInfo.data && userInfo.data.age >= 18;

    return (
        <section className="payment-settings-page">
            {!featureToggles.disableEfaktura && (
                <Content>
                    <h2>{translated.paymentSettings.eFaktura}</h2>
                    <LinkList className="settings__link-list">
                        <EfakturaAgreement />
                    </LinkList>
                </Content>
            )}
            {!featureToggles.disableAvtalegiro && avtalegiroLink?.url && (
                <Content>
                    <h2>{translated.paymentSettings.avtaleGiro}</h2>
                    <LinkList className="settings__link-list">
                        <LinkList.Item href={avtalegiroLink.url}>
                            {translated.paymentSettings.addAndEditAgreements}
                        </LinkList.Item>
                    </LinkList>
                </Content>
            )}
            {isOfLegalAge && featureToggles.enablePaymentLimits && paymentLimitsLink?.url && (
                <Content>
                    <h2>{translated.paymentSettings.paymentLimits}</h2>
                    <LinkList className="settings__link-list">
                        <LinkList.Item href={paymentLimitsLink.url}>
                            {translated.paymentSettings.editPaymentLimits}
                        </LinkList.Item>
                    </LinkList>
                </Content>
            )}
        </section>
    );
};

export default PaymentSettings;
